module.exports = __webpack_public_path__ + "img/outlander-sport-19.546cd3b5.png";